import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TsIsObjectPipe } from './ts-is-object';
import { TsGroupByPipe } from './ts-group-by/ts-group-by.pipe';
import { TsFilterByPipe } from './ts-filter-by/ts-filter-by.pipe';
import { TsMutateToAnyPipe } from './ts-mutate-to-any/ts-mutate-to-any.pipe';
import { TsFieldFromNamePipe } from './ts-field-from-name/ts-field-from-name.pipe';
import { TsOperatorDisplayPipe } from './ts-operator-display/ts-operator-display.pipe';
import { TsSelectOptionsSearchPipe } from './ts-select-options-search/ts-select-options-search.pipe';

@NgModule({
  declarations: [
    TsOperatorDisplayPipe,
    TsFieldFromNamePipe,
    TsGroupByPipe,
    TsFilterByPipe,
    TsMutateToAnyPipe,
    TsIsObjectPipe,
    TsSelectOptionsSearchPipe,
  ],
  imports: [CommonModule],
  exports: [
    TsOperatorDisplayPipe,
    TsFieldFromNamePipe,
    TsGroupByPipe,
    TsFilterByPipe,
    TsMutateToAnyPipe,
    TsIsObjectPipe,
    TsSelectOptionsSearchPipe,
  ],
})
export class TsPipesModule {}
